import { useMemo } from 'react';
import { useAuthenticationService } from '../services/authentication.service';
import {
  ROLE_CENTRE_READONLY,
  ROLE_CENTRE_READWRITE,
  ROLE_CENTRE_SUPERADMIN,
  ROLE_PROPERTY_READONLY,
  ROLE_PROPERTY_READWRITE,
  ROLE_PROPERTY_SUPERADMIN,
} from '../utils/constants/roles';

export default function useRoles() {
  const auth = useAuthenticationService();

  return useMemo(() => {
    const has = (role) => auth.isInAnyRole([role]);

    const hasPropertyAccess = has(ROLE_PROPERTY_READONLY) || has(ROLE_PROPERTY_READWRITE) || has(ROLE_PROPERTY_SUPERADMIN);
    const canEditCentre = has(ROLE_CENTRE_READWRITE) || has(ROLE_CENTRE_SUPERADMIN);
    const canEditProperty = has(ROLE_PROPERTY_READWRITE) || has(ROLE_PROPERTY_SUPERADMIN);
    const canDeleteCentre = has(ROLE_CENTRE_SUPERADMIN);
    const canDeleteProperty = has(ROLE_PROPERTY_SUPERADMIN);
    const canDeleteLicence = has(ROLE_CENTRE_SUPERADMIN);
    const canCreateCentre = has(ROLE_CENTRE_READWRITE) || has(ROLE_CENTRE_SUPERADMIN);

    return {
      hasPropertyAccess,
      canEditCentre,
      canEditProperty,
      canDeleteCentre,
      canDeleteProperty,
      canDeleteLicence,
      canCreateCentre,
    };
  }, [auth]);
}
